import { Item } from "@thenounproject/lingo-core";
import { createAction } from "../actionCreators";

type Args = {
  item: Pick<Item, "id" | "version" | "asset">;
  format: string;
};

const [useTrackColorUsage, trackColorUsage] = createAction<Args>("analytics/trackColorUsage");

export default useTrackColorUsage;
export { trackColorUsage };
